export enum DriverSelectionType {
    EXISTING = 'EXISTING',
    NEW = 'NEW',
    NONE = 'NONE',
}
